import type { SVGProps } from "react";

/**
 * dices, random, roll
 * @category Gaming
 */
export default function IconDices(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M2.11364 13.8828C1.64683 12.8817 2.07994 11.6918 3.08102 11.2249L8.06571 8.90054C9.06679 8.43373 10.2568 8.86684 10.7236 9.86792L13.048 14.8526C13.5148 15.8537 13.0817 17.0437 12.0806 17.5105L7.0959 19.8349C6.09482 20.3017 4.90485 19.8686 4.43804 18.8675L2.11364 13.8828Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <path
        d='M14.475 4.6395C14.8528 3.60155 16.0005 3.06637 17.0384 3.44416L20.3273 4.64123C21.3653 5.01901 21.9005 6.1667 21.5227 7.20465L20.3256 10.4936C19.9478 11.5315 18.8001 12.0667 17.7622 11.6889L14.4733 10.4919C13.4353 10.1141 12.9001 8.96638 13.2779 7.92843L14.475 4.6395Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <path
        d='M6.41045 13.3519C6.64386 13.8524 6.4273 14.4474 5.92676 14.6808C5.42622 14.9142 4.83124 14.6977 4.59784 14.1971C4.36443 13.6966 4.58099 13.1016 5.08153 12.8682C5.58207 12.6348 6.17705 12.8514 6.41045 13.3519Z'
        fill='currentColor'
      />
      <path
        d='M10.3987 14.8031C10.6321 15.3036 10.4156 15.8986 9.91504 16.132C9.4145 16.3654 8.81952 16.1488 8.58612 15.6483C8.35271 15.1478 8.56927 14.5528 9.06981 14.3194C9.57035 14.086 10.1653 14.3025 10.3987 14.8031Z'
        fill='currentColor'
      />
      <path
        d='M18.4391 7.84205C18.2503 8.36103 17.6764 8.62861 17.1574 8.43972C16.6385 8.25083 16.3709 7.67699 16.5598 7.15801C16.7487 6.63903 17.3225 6.37144 17.8415 6.56034C18.3605 6.74923 18.628 7.32307 18.4391 7.84205Z'
        fill='currentColor'
      />
    </svg>
  );
}
